const Card = ({ children, className }) => {   
    return (
      <div className={`mx-auto border rounded-lg ${className}`} >
        {children}
      </div>
    );
  }    

  export default Card;